import script from "./CostDataHeaderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CostDataHeaderDetail.vue?vue&type=script&setup=true&lang=js"

import "./CostDataHeaderDetail.vue?vue&type=style&index=0&id=7cad8de0&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cad8de0"]])

export default __exports__